<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <h3
        v-if="title"
        class="text-center"
      >
        Clientes Sem Movimentação
      </h3>
      <canvas
        id="myChartMaisVida3"
        width="100"
        height="50"
      />
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import PositivacaoCliente from '../../../../services/positivacaocliente'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardPositivacaoClientes',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      title: false,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      produtos: [],
      linhas: [],
      volume: [],
      precoMedio: [],
      clientes: [],
      segmento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      valorExibicao: false,
      montarGrafico: true,
      loading: false,
      error: null,
      valorMes: 2,
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, segmento) {
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.segmento = segmento

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.title = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await PositivacaoCliente.showGraficoClientesSemMovimentacao(this.empresaSelect, this.cidades, this.areas, this.vendedores, this.redes, localStorage.tokencontrato, this.valorMes, this.segmento).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChartMaisVida3').getContext('2d')

            this.title = true

            this.myChart = new Chart(ctx, {
              type: 'line',
              data: {
                labels: resposta.data.datas,
                datasets: [
                  {
                    label: 'Clientes Sem Movimento',
                    data: resposta.data.dadosMovimentos,
                    backgroundColor: 'transparent',
                    borderColor: '#2863af',
                    order: 1,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                },
                low: 10,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return 'Clientes sem movimentação: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.title = false

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para exibir montar ao gráfico') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">
  #myChartMaisVida1
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    width: 380
    height: 250

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
</style>
